import { getCurrentUser } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import React from 'react'

type CognitoOpts = {
    onChange: (signedIn: boolean) => void
}

export const useCognito = (opts?: CognitoOpts) => {
    const [signedIn, _setSignedIn] = React.useState<boolean>()

    const setSignedIn = (v: boolean) => {
        if (opts?.onChange) {
            opts.onChange(v)
        }
        _setSignedIn(v)
    }

    const authListener = React.useCallback(({ payload: { event } }) => {
        // eslint-disable-next-line no-console
        console.log('new auth event: ', event)
        // eslint-disable-next-line default-case
        switch (event) {
            case 'signIn':
                setSignedIn(true)
                break
            case 'signOut':
                setSignedIn(false)
                break
        }
    }, [])

    const checkLoginStatus = async () => {
        try {
            await getCurrentUser()
            setSignedIn(true)
        } catch (error) {
            setSignedIn(false)
        }
    }

    React.useEffect(() => {
        const unsubscribe = Hub.listen('auth', authListener)

        checkLoginStatus().then()

        return unsubscribe
    })

    return { signedIn, setSignedIn }
}
